
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11198",
                "data-name": "矩形 11198",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.129 0.064)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_239",
        "data-name": "蒙版组 239",
        "class": "cls-2",
        "transform": "translate(-0.129 -0.064)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "zaocan",
            "class": "cls-1",
            "d": "M81.293,111.692a.654.654,0,0,1,0,1.308H64.579a.654.654,0,0,1,0-1.308ZM72.936,96a2.567,2.567,0,0,1,2.3,1.445,2.654,2.654,0,0,1-.242,2.739,8.479,8.479,0,0,1,6.3,8.242v1.962H64.58v-1.962a8.479,8.479,0,0,1,6.3-8.242,2.654,2.654,0,0,1-.241-2.738A2.567,2.567,0,0,1,72.936,96Zm0,5.232a7.133,7.133,0,0,0-7.07,7.194v.654H80.006v-.654A7.133,7.133,0,0,0,72.936,101.232Zm0-3.924a1.308,1.308,0,1,0,1.286,1.308A1.3,1.3,0,0,0,72.936,97.308Z",
            "transform": "translate(-60.807 -91.936)"
          }
        }
      ]
    }
  ]
})
    }
  